import React from 'react'
import classNames from 'classnames'
import Button from './components/Button'

import './BannerList.scss'

const BannerList: React.FunctionComponent<{
  ids: readonly string[]
  onClick: (id: string) => void
  showButton: boolean
}> = ({ ids, onClick, showButton }) => {
  return (
    <>
      {
        ids.slice(-5).map((id, i, arr) => (
          <div
            key={id}
            className={classNames('BannerListBanner', { covered: i < arr.length - 1 })}
          >
            <div className="content">
              <div className="description">
                This has been added to your List
              </div>
              {showButton && (
                <Button
                  buttonStyle="whiteStroke"
                  onClick={() => onClick(id)}
                >
                  View My List
                </Button>
              )}
            </div>
          </div>
        ))
      }
    </>
  )
}

export default BannerList
